<template>
  <div class="billing-payment-sepa-bank-transfer">
    <div v-loading="formLoading">
      <div
        class="billing-payment-sepa-bank-transfer__wrap"
        :class="{ 'billing-payment-sepa-bank-transfer__loaded': !formLoading }"
      >
        <div :id="zuoraContainerId"></div>
      </div>
      <zm-alert
        v-if="paymentError"
        type="error"
        show-icon
        :closable="false"
        class="billing-payment-sepa-bank-transfer__error"
      >
        <p class="billing-payment-sepa-bank-transfer__error--desc" v-html="paymentError" />
      </zm-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { APP_NAMESPACE } from '../../store'
import PaymentBase from './common/PaymentBase'
import Ready from '../../common/ready'
import { logger } from '../../utils/log'
import { translateMixins } from '../../plugins/i18n'
import { ERROR_MAPPING, payMethodMap, Z_HPM_IFRAME } from '../../common/constant'
import zuoraMixin from './mixins/zuora-mixin'

export default {
  name: 'SepaBank',
  extends: PaymentBase,
  mixins: [translateMixins, zuoraMixin],
  props: {
    isFormVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validateInstance: new Ready()
    }
  },
  mounted() {
    if (this.isFormVisible) {
      this.initSepaBankTransferForm()
    }
  },
  beforeDestroy() {
    logger.log('SEPA HPM before destroy.........................................')
    document.getElementById(Z_HPM_IFRAME)?.removeEventListener('load', this.zuoraOnLoadEventListener)
    this.resetFormState()
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, ['billingInfoConfig']),
    errorMapping() {
      return Object.assign({}, ERROR_MAPPING['DEFAULT'], ERROR_MAPPING['SEPA'])
    }
  },
  methods: {
    ...mapMutations(APP_NAMESPACE, ['setSepaAuthRequestInitiated']),
    initSepaBankTransferForm() {
      this.loadHpmIframe(payMethodMap.sepa)
      this.listenToZuoraMessage()
    },
    async $submit() {
      // validate zuora hpm form
      await this.validateHpmForm(payMethodMap.sepa)
      // submit zuora hpm form
      const paymentInfo = await this.submitHpmForm(payMethodMap.sepa)
      await this.updatePayMethodAndContactForm(paymentInfo)
      this.setSepaAuthRequestInitiated(true)
      return paymentInfo
    }
  },
  watch: {
    isFormVisible: {
      handler(isFormVisible) {
        this.resetFormState()
        if (isFormVisible) {
          this.clearPaymentError()
          this.initSepaBankTransferForm()
        } else {
          document.getElementById(Z_HPM_IFRAME)?.removeEventListener('load', this.zuoraOnLoadEventListener)
          this.resetFormState()
          document.getElementById(Z_HPM_IFRAME)?.remove()
          clearInterval(this.resizeHpmOnIntervalRef)
          logger.log('SEPA HPM was unloaded.........................................')
        }
      }
    },
    formLoading: {
      handler(_, newFormLoading) {
        if (newFormLoading) {
          this.ready()
        }
      }
    }
  },
  destroyed() {
    logger.log('SEPA bank component was destroyed')
  }
}
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
.billing-payment-sepa-bank-transfer {
  #z_hppm_iframe {
    background: transparent;
    width: 100%;
  }
  &__wrap {
    margin-top: 16px;
    margin-bottom: 24px;
    padding: 24px 6px 16px;
    border-radius: 10px;
    overflow: hidden;
  }

  &__loaded {
    background: #f2f2f4;
    border: 1px solid #dfdfe4;
  }

  #zuora_payment {
    width: 534px;
    height: auto;
    min-height: 250px;
    margin: auto;
    overflow: hidden;
    @include media(mobile, tablet) {
      width: 100%;
      padding: 0 6px;
    }
  }

  &__error {
    background-color: #f3c2d0;
    color: #80384d;
    margin-bottom: 15px;

    &--desc {
      word-break: break-word;
    }
  }

  &__action {
    display: flex;
    margin-top: 24px;

    &.justify-end {
      justify-content: flex-end;
    }

    .zm-button {
      font-weight: 600 !important;
    }

    &__cancel {
      &.zm-button {
        margin-left: 16px;
      }
    }
  }
}
</style>
